import script from "./AccountClients.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountClients.vue?vue&type=script&lang=ts&setup=true"

import "./AccountClients.vue?vue&type=style&index=0&id=841b7e18&lang=css"

const __exports__ = script;

export default __exports__